var root = require('./_root');

/** Built-in value references. */
var Reflect = root.Reflect;

module.exports = Reflect;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-touch/node_modules/lodash/_Reflect.js
// module id = ./node_modules/react-touch/node_modules/lodash/_Reflect.js
// module chunks = main